module.exports = __webpack_public_path__ + "static/media/Meda - DK Grey_LT Grey.4dc16443.jpg";